import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Instagram } from 'lucide-react';
import SEO from '../components/SEO';
import ContactActions from '../components/ContactActions';

const Home = () => (
  <>
    <SEO
      title="Wedding & Event Photographer in Lucknow | Frames by Gaurav"
      description="Wedding and event photography in Lucknow by Frames by Gaurav. Explore our work, packages and availability for your celebration."
      keywords="photography lucknow, wedding photographer lucknow, event photography, fashion photography, commercial photography, photographer near me, frames by gaurav, gaurav vishwakarma photographer, best wedding photographer lucknow"
      canonicalUrl="/"
      structuredData={{
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Home - Frames by Gaurav',
        description:
          'Professional photography studio in Lucknow specializing in wedding photography, event coverage, and commercial shoots.',
        url: 'https://www.framesbygaurav.com/',
      }}
    />
    <ContactActions />
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-black">
      <a
        href="https://www.instagram.com/_btsandbeyond_"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-6 top-6 z-50 text-white transition-colors hover:text-gray-300"
        aria-label="Instagram"
      >
        <Instagram size={32} />
      </a>

      <div className="absolute inset-0" aria-hidden="true">
        <img
          src="https://images.pexels.com/photos/37380248/pexels-photo-37380248.jpeg"
          alt=""
          className="h-full w-full object-cover"
          style={{ opacity: 0.4 }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-6xl px-6 text-center">
        <h1 className="hero-title mb-6 text-6xl font-bold tracking-tight text-white md:text-8xl">
          <img
            src="/frames-by-gaurav-logo.svg"
            alt="Frames By Gaurav"
            className="mx-auto block h-auto w-full max-w-[480px] brightness-0 invert"
            fetchPriority="high"
          />
        </h1>
        <p className="mb-12 text-xl tracking-wide text-gray-300 md:text-2xl">
          Capturing Moments, Creating Memories
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/gallery"
            className="group inline-flex items-center bg-white px-8 py-4 text-sm uppercase tracking-widest text-black transition-all duration-300 hover:bg-gray-200"
          >
            Explore Our Work
            <ArrowRight
              className="ml-2 transition-transform group-hover:translate-x-1"
              size={20}
            />
          </Link>
          <Link
            to="/contact"
            className="border border-white px-8 py-4 text-sm uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black"
          >
            Check Availability
          </Link>
        </div>
      </div>
    </main>
  </>
);

export default Home;
